import React, { useCallback } from 'react';
import useSuperRights from 'src/hooks/settings/useSuperRights';
import CheckBox from 'src/components/Inputs/CheckBox';
import { Box } from '@material-ui/core';
function SuperRightsCheckbox() {
    const { isSuperEnabled, toggleSuper } = useSuperRights();
    const handleChange = useCallback(() => {
        toggleSuper();
    }, [toggleSuper]);
    return (React.createElement(Box, { pt: 1 },
        React.createElement(CheckBox, { label: "Ektaco superuser", checked: isSuperEnabled, onChange: handleChange })));
}
export default SuperRightsCheckbox;
